var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chip-status",class:'chip-status--' + _vm.aparencia.classe},[_c('span',{staticClass:"chip-status__dot"}),_vm._v(" "+_vm._s(_vm.aparencia.rotulo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }